// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ad33ef97","453":"e684f3a2","732":"f6d8d09e"}[chunkId] + ".chunk.js";
};